import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BaseAutoCompleteWithSingleSelectedItem from '@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue';
import getOperationOffice from '@/types/responses/getOperationOffice';
import getDeviceResponse from '@/types/responses/getDevice';
import { onMounted, ref, computed } from 'vue';
import Api from '@/services/api/ApiServiceFabrick';

type Item = getDeviceResponse & { operationOfficeId: number };


export default /*@__PURE__*/_defineComponent({
  __name: 'DeviceIdAutoComplete',
  props: {
    modelValue: {},
    label: { default: 'デバイスID' },
    itemName: { default: 'device_id' },
    operationOffices: {},
    errorMessages: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const items = ref<Item[]>([]);

onMounted(() => {
  Api()
    .autoComplete.devices()
    .then((data) => {
      items.value = data.map((data) => {
        // キーの名前をスネークケースからキャメルケースに変換する
        return {
          ...data,
          operationOfficeId: data.operation_office_id,
        };
      });
    });
});

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseAutoCompleteWithSingleSelectedItem, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
    label: __props.label,
    itemName: __props.itemName,
    items: items.value,
    "operation-offices": __props.operationOffices,
    "error-messages": __props.errorMessages
  }, null, 8, ["modelValue", "label", "itemName", "items", "operation-offices", "error-messages"]))
}
}

})